import {
  BRAND_TITLES,
  type BrandLogoVariant,
  getBrandLogoUrl,
  isBrand,
  useTheme,
} from '@frontends/util-theme-provider';
import { useEntityConfig } from '@/hooks/useEntityConfig';
import { BRAND_ASSET_VERSION_QUERY } from '@/lib/brand';

interface BrandLogo {
  alt: string;
  src: string;
}

export function useBrandLogo(variant: BrandLogoVariant): BrandLogo | null {
  const config = useEntityConfig();
  const { resolvedMode } = useTheme();
  const entity = config.VITE_ENTITY;

  if (!isBrand(entity)) {
    return null;
  }

  return {
    src: `${getBrandLogoUrl(entity, variant, resolvedMode)}${BRAND_ASSET_VERSION_QUERY}`,
    alt: BRAND_TITLES[entity],
  };
}

const Logo = ({ className }: { className: string }) => {
  const logo = useBrandLogo('full');

  if (!logo) return null;

  return <img src={logo.src} alt={logo.alt} className={className} />;
};

export default Logo;
